import React, { forwardRef } from "react";
import { Snackbar, Alert } from "@mui/material";

const SnackbarNotification = forwardRef((props, ref) => {
  const { open, message, severity, onClose, duration = 4000 } = props;

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert onClose={onClose} severity={severity} variant="filled" ref={ref}>
        {message}
      </Alert>
    </Snackbar>
  );
});

export default SnackbarNotification;
